import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["value"]
const _hoisted_2 = { class: "quiz__answer-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("label", null, [
    _createElementVNode("input", {
      type: "radio",
      name: "answers",
      class: "quiz__answer-input",
      ref: "inputRef",
      value: _ctx.id,
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value)))
    }, null, 40, _hoisted_1),
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.title), 1)
  ]))
}